export default __webpack_public_path__ + "static/security-cc935b6de0c315ecdd254df1aa65ae2e.svg";